import { TableCell } from './table-cell';

export class TableTh extends TableCell {

  sortable: boolean;

  constructor(columnId: string = null) {
      super();
      this.columnId = columnId;
      this.sortable = false;
  }
}
